import React from 'react'

import { trackedClick } from '../utils'
import SvgIcon from '../components/SvgIcon'

const linkTypeToIcon = {
    home: 'home',
    demo: 'home',
    legal: 'libra',
    signup: 'key',
    pricing: 'dollar',
    docs: 'book',
    hidden: 'book',
    code: 'cogwheel',
    spec: 'cogwheel',
    sdk: 'cogwheel',
    news: 'rss',
    discuss: 'rss',
}

const DocLink = ({ type, url, title }) => (
    <li className="resource-links__item">
        <a
            className="resource-links__item-link"
            href={url}
            title={title}
            onClick={trackedClick('API Links link clicked', {
                source: 'API page',
                title,
            })}
            target="_blank"
            rel="noopener noreferrer"
        >
            <span className="resource-links__item-icon">
                <SvgIcon slug={linkTypeToIcon[type] || type} />
            </span>
            {title}
        </a>
    </li>
)

export default DocLink



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/DocLink.jsx